import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { disablePopupsAction, enablePopupsAction } from 'js/components/common/PopupManager';

import {
    EVOLUTION_COMMANDS,
    EVOLUTION_EVENTS
} from '../constants';

export const useGameLifecycleSubscription = () => {
    const dispatch = useDispatch();
    const messageHandler = useCallback((message) => {
        const {
            event,
            source,
            interruptAllowed
        } = message?.data || {};

        switch (event) {
            case EVOLUTION_EVENTS.APPLICATION_READY:
                source?.postMessage({
                    command: EVOLUTION_COMMANDS.EVENT_SUBSCRIBE,
                    event: EVOLUTION_EVENTS.GAME_LIFECYCLE
                }, '*');
                break;

            case EVOLUTION_EVENTS.GAME_LIFECYCLE:
                if (interruptAllowed) {
                    dispatch(enablePopupsAction());
                    source?.postMessage({
                        command: EVOLUTION_COMMANDS.EXIT_FULLSCREEN
                    }, '*');
                } else {
                    dispatch(disablePopupsAction());
                }
                break;

            default:
            // noop
        }
    }, [
        dispatch
    ]);

    useEffect(() => {
        window.addEventListener('message', messageHandler);

        return () => {
            window.removeEventListener('message', messageHandler);
        };
    });
};
